import { Phone, Mail, MapPin, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { KRAFT } from '@/constants/testIds';
import { FACEBOOK_GROUP_URL } from '@/components/Gallery';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={KRAFT.footerRoot}
      className="relative bg-ink-950 border-t border-white/10 py-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div>
              <div className="font-display uppercase text-white text-2xl tracking-tight leading-none">
                Kraft<span className="text-volt">·</span>Performance
              </div>
              <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400 mt-1">
                Elektryk · Warszawa
              </div>
            </div>
            <p className="mt-6 max-w-md text-slate-400 text-sm leading-relaxed">
              Instalacje elektryczne w oparciu o Prawo Budowlane, uprawnienia SEP D+E oraz normy BHP.
            </p>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400 mb-4">Kontakt</div>
            <div className="space-y-3">
              <a href="tel:+48731842736" className="flex items-center gap-3 text-slate-200 hover:text-volt transition-colors">
                <Phone className="w-4 h-4 text-volt" />
                <span className="font-mono text-sm">+48 731 842 736</span>
              </a>
              <a href="tel:+48886538014" className="flex items-center gap-3 text-slate-200 hover:text-volt transition-colors">
                <Phone className="w-4 h-4 text-volt" />
                <span className="font-mono text-sm">+48 886 538 014</span>
              </a>
              <a href="mailto:bigslavca0802@gmail.com" className="flex items-center gap-3 text-slate-200 hover:text-volt transition-colors">
                <Mail className="w-4 h-4 text-volt" />
                <span className="font-mono text-sm">bigslavca0802@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-slate-200">
                <MapPin className="w-4 h-4 text-volt mt-1" />
                <span className="text-sm leading-relaxed">Wał Miedzeszyński 466U<br />03-994 Warszawa</span>
              </div>
              <a
                data-testid={KRAFT.footerFacebookLink}
                href={FACEBOOK_GROUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-200 hover:text-volt transition-colors"
              >
                <Facebook className="w-4 h-4 text-volt" />
                <span className="font-mono text-sm">Grupa branżowa · Facebook</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400 mb-4">Godziny</div>
            <ul className="space-y-2 text-sm text-slate-300">
              <li className="flex justify-between"><span>Pn — Pt</span><span className="font-mono">07:00–18:00</span></li>
              <li className="flex justify-between"><span>Sobota</span><span className="font-mono">07:00–14:00</span></li>
              <li className="flex justify-between"><span>Niedziela</span><span className="font-mono text-red-400">Zamknięte</span></li>
            </ul>
            <div className="mt-6 border border-volt/50 p-3 bg-ink-900">
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-volt mb-1">Poza godzinami</div>
              <div className="font-display uppercase text-white text-sm tracking-wide">Pogotowie 24/7</div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
            © {year} Kraft-Performance · Wszelkie prawa zastrzeżone
          </div>
          <div className="flex items-center gap-6">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500 hidden sm:block">
              NIP · REGON dostępne na życzenie
            </div>
            <Link
              data-testid={KRAFT.footerAdminLink}
              to="/admin"
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500 hover:text-volt transition-colors"
            >
              Panel
            </Link>
          </div>
        </div>

        {/* Agency credit — W12E */}
        <div className="mt-6 flex items-center justify-start">
          <a
            data-testid={KRAFT.footerAgencyLink}
            href="https://w12e-agency.emergent.host/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Realizacja strony — W12E Agency"
            title="Realizacja strony — W12E Agency"
          >
            <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500 group-hover:text-slate-300 transition-colors">
              Realizacja
            </span>
            <span className="w-px h-6 bg-white/10" />
            <img
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_elektryk-profi/artifacts/fasu0c6b_Logo%20W12E.png"
              alt="W12E Agency — projekt i realizacja strony"
              className="h-8 w-auto object-contain"
              style={{ filter: 'invert(1)', mixBlendMode: 'screen' }}
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
